// const os = require('os');
// const isWindows = os.platform() === 'win32';

module.exports = {
  devServer: {
    proxy: process.env.VUE_APP_API_URL,
    // hot: true,
    // liveReload: true,
    // watchOptions: {
    //   poll: isWindows ? 1000 : false,  // Poll only on Windows
    //   aggregateTimeout: 300,
    //   ignored: /node_modules/,         // Don’t watch node_modules
    // },
  },

  transpileDependencies: [
    'vuetify'
  ]
};
